import { render, staticRenderFns } from "./showBox.vue?vue&type=template&id=dd694f9c&scoped=true"
import script from "./showBox.vue?vue&type=script&lang=js"
export * from "./showBox.vue?vue&type=script&lang=js"
import style0 from "./showBox.vue?vue&type=style&index=0&id=dd694f9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd694f9c",
  null
  
)

export default component.exports